<app-page-modifications>
    <app-header class="full-width"></app-header>
    <main id="content" class="js-content" role="main">
        <div class="grid-row">
            <div class="column-full" *ngIf="!familiarisationCheck">
                <header class="page-header">
                    <h1 class="heading-xlarge aa-title-size" tabindex="0">Out of time</h1>
                </header>
                <p class="notice" tabindex="0">
                    <strong class="visually-hidden">Warning</strong>
                    <app-svg-warning></app-svg-warning>
                    <strong class="aa-copy-size">Please tell your teacher</strong>
                </p>
                <details>
                    <summary><span class="summary aa-copy-size">Instructions for teachers</span></summary>
                    <div class="panel no-border">
                        <ol class="list list-number aa-copy-size">
                            <li>If your check was interrupted, you may want to consider a restart.</li>
                            <li>Go to ‘Restarts’ & select ‘Did not complete’ with the reason ‘Timed out’.</li>
                            <li>Select the pupil.</li>
                            <li>Generate a new PIN for the pupil.</li>
                            <li>Sign the pupil out and then back in.</li>
                        </ol>
                    </div>
                </details>
                <p>
                    <a id='sign-out' routerLink="/sign-out" class="button aa-button-size wider aa-contrast-button">Sign out</a>
                </p>
            </div>
          <div class="column-full" *ngIf="familiarisationCheck">
            <header class="page-header">
              <h1 class="heading-xlarge aa-title-size" tabindex="0">Out of time</h1>
            </header>
            <p class="notice" tabindex="0">
              <strong class="visually-hidden">Warning</strong>
              <app-svg-warning></app-svg-warning>
              <strong class="aa-copy-size">To try the check again, please sign out and sign in using your <br /> most recent 'Try it out' username and PIN</strong>
            </p>
            <br />
            <a routerLink="/sign-out" class="button aa-button-size wider aa-contrast-button" id="next-pupil-button">Sign out</a>
          </div>
        </div>
    </main>
</app-page-modifications>
